import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import * as Yup from "yup";
import LoginPage from "./loginPage";
import { useMutation, useQueryClient } from "react-query";
import { sendOtp } from "../../services/security.service";
import { MOBILE_NUMBER, REFERENCE_NUMBER } from "../../config/cacheKey";
import { Button } from "@material-ui/core";
import { SendOtpRequest } from "../../models/security.model";
import { useHistory } from "react-router-dom";
import { log } from "console";

function _loginByOtp() {
  const mobileValid = Yup.object({
    mobileNumber: Yup.string().required(),
  });

  const [selectedCount, setSelectedPart] = React.useState();
  const [isBtnNextDeactived, setIsBtnNextDeactived] = useState<boolean>(true);
  const history = useHistory();
  const queryClient = useQueryClient();
  const sendOtpMutation = useMutation(sendOtp, {
    onSuccess: (data: string) => {
      if (data) {
        queryClient.setQueryData(REFERENCE_NUMBER, data);
        history.push("/otp");
      }
    },
  });

  const mobileNumberCodeHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;
    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
    if (
      event.target.value.length >= yupMobileMax &&
      key != 8 &&
      key != 46 &&
      selectedCount === 0
    ) {
      event.preventDefault();
    }
  };

  const currentSelection = (e: any) => {
    setSelectedPart(
      e.target.value.substring(e.target.selectionStart, e.target.selectionEnd)
        .length
    );
  };

  const yupMobileMax = 11;
  const validationSchema = Yup.object().shape({
    mobileNumber: Yup.string()
      .required("شماره موبایل اجباری می باشد")
      .matches(/^[0-9]+$/, "شماره موبایل فقط عدد می باشد")
      .min(yupMobileMax, "شماره موبایل یازده رقم است")
      .max(yupMobileMax, "شماره موبایل فقط یازده عدد است"),
  });

  const changeLoginPage = () => {
    history.push("/login");
  };

  return (
    <>
      <Typography
        className="iranSansMedium textCenter  fontWeight colorBase  textFont20"
        style={{ marginTop: "5vh", marginBottom: "5vh" }}
      >
        ورود به حساب کاربری
      </Typography>
      <Formik
        initialValues={new SendOtpRequest()}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          queryClient.setQueryData(MOBILE_NUMBER, values.mobileNumber);
          sendOtpMutation.mutate(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
          touched,
          handleBlur,
        }) => (
          <form
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            <div style={{ marginTop: "10vh", marginBottom: "5vh" }}>
              <MaterialTextFieldComponent
                autoFocus={true}
                helperText={!touched.mobileNumber ? errors.mobileNumber : ""}
                error={!touched.mobileNumber && Boolean(errors.mobileNumber)}
                label="شماره موبایل"
                placeHolder={"*شماره موبایل خود را وارد کنید "}
                required={true}
                type="text"
                value={values.mobileNumber}
                onChange={handleChange}
                name="mobileNumber"
                id="mobileNumber"
                onKeyDown={mobileNumberCodeHandleKeyDown}
                onSelect={currentSelection}
              />
            </div>
            <Button
              style={{ marginTop: "6vh" }}
              type="submit"
              fullWidth
              variant="contained"
              disabled={Object.keys(errors).length > 0 || !values.mobileNumber}
              className={`${
                Object.keys(errors).length > 0 || !values.mobileNumber
                  ? "btnForm deactivatedButton Vazirmatn "
                  : "btnForm activatedButton Vazirmatn "
              }`}
            >
              ارسال کد
            </Button>
            <div
              onClick={changeLoginPage}
              style={{
                marginTop: "30px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <span className="titleCardGreen cursorPointer ">
                ورود با نام کاربری
              </span>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}

export default function LoginByOtp() {
  const childForm = <_loginByOtp />;

  return (
    <Box sx={{ flexGrow: 2, overflow: "hidden", px: 3 }}>
      <LoginPage childForm={childForm} onBtnNext={() => console.log("")} />
    </Box>
  );
}
